export const COOKIE_CAMPAIGN_CODE = 'campaign_code';
